import { Filter } from '../models/table-models';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { DatePickerWrapper } from './DatePickerWrapper';
import dateFormat from 'dateformat';

export interface DateFilterComponentProps {
    filter: Filter;
    setFilter: React.Dispatch<React.SetStateAction<Filter>>;
    allowFutureDates?: boolean;
}

export const DateFilterComponent = ({ filter, setFilter, allowFutureDates = false }: DateFilterComponentProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const today = dateFormat(new Date(), 'yyyy-mm-dd');
    let fromDateMaxDate = filter.before;

    if (!allowFutureDates) {
        fromDateMaxDate = filter.before && new Date(filter.before) < new Date() ? filter.before : today;
    }

    const toDateMaxDate = allowFutureDates ? undefined : today;

    const onChange = (value: string, field: string) => {
        if (value === 'cleared') value = '';
        setFilter({ ...filter, [field]: value });
    };

    return (
        <div className='d-flex flex-column flex-md-row text-nowrap m-1 gap-2 align-items-stretch align-items-md-center date-filter-container'>
            <div className='d-flex align-items-center gap-2 date-filter-field'>
                <h5 className='mb-0'>{t('fromDate')}:</h5>
                <DatePickerWrapper
                    isClearable
                    maxDate={fromDateMaxDate}
                    selected={filter.after}
                    onChange={(value) => onChange(value === 'cleared' ? '' : value, 'after')}
                />
            </div>
            <div className='d-flex align-items-center gap-2 date-filter-field'>
                <h5 className='mb-0'>{t('toDate')}:</h5>
                <DatePickerWrapper
                    isClearable
                    minDate={filter.after}
                    maxDate={toDateMaxDate}
                    selected={filter.before}
                    onChange={(value) => onChange(value === 'cleared' ? '' : value, 'before')}
                />
            </div>
        </div>
    );
};
